import React, { useState } from "react";
import styled from "styled-components";
import Faqs from "../data/rushdata.json";
import Faqs2 from "../data/rushdata.json";
import FaqItem from "./FaqItem";

function Faq() {
  const [faqData] = useState(Faqs.faq1);
  const [faqData2] = useState(Faqs2.faq2);

  const [faqButton, setfaqButton] = useState(1);

  return (
    <FaqWrapper>
      <div className="section-center">
        <div className="faq__btn">
          <button
            className={`heading-text ${faqButton === 1 ? "active" : undefined}`}
            onClick={() => setfaqButton(1)}
          >
            For Customers
          </button>
          <button
            className={`heading-text ${faqButton === 2 ? "active" : undefined}`}
            onClick={() => setfaqButton(2)}
          >
            For Drivers
          </button>
        </div>

        <div className="faq">
          {faqButton === 1
            ? faqData.map((element, index) => {
                return (
                  <FaqItem
                    ind={index}
                    key={element.id}
                    faq_Qs={element.faq_qs}
                    faq_Ans1={element.faq_ans1}
                    faq_Ans2={element.faq_ans2}
                  />
                );
              })
            : undefined}
        </div>

        <div className="faqSecond">
          {faqButton === 2
            ? faqData2.map((element, index) => {
                return (
                  <FaqItem
                    ind={index}
                    key={index}
                    faq_Qs={element.faq_qs}
                    faq_Ans1={element.faq_ans1}
                    faq_Ans2={element.faq_ans2}
                    faq_Ans3={element.faq_ans3}
                  />
                );
              })
            : undefined}
        </div>
      </div>
    </FaqWrapper>
  );
}

const FaqWrapper = styled.div`
  svg.MuiSvgIcon-root {
    fill: #232323de !important;
    width: 37px !important;
    height: 2em !important;
  }

  .heading-text.active {
    border-bottom: 3.5px solid #2c5282;
  }

  .faq {
    margin-top: 100px;
  }
  .faq__btn {
    text-align: center;
  }

  button.heading-text {
    font-family: Gilroy;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    color: #2c5282;
    outline: none;
    border: none;
    padding: 16px;
    margin: 7px;
    background: transparent;
  }

  .drivers_text {
    padding-top: 102px;
  }
`;

export default Faq;
